import { Directive, ElementRef, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { AppServiceService } from './app-service.service';
import { UserDetailsMainModel } from './user-details-model';

const DISABLED = 'disabled';

@Directive({
  selector: '[appGreyedOut]'
})
export class GreyedOutDirective implements OnInit {

  userDetails: UserDetailsMainModel;
 
  constructor(private ele: ElementRef, private renderer: Renderer2,
    private appService: AppServiceService,
  ) {
    this.appService.userDetails.subscribe(d => this.userDetails = d);
    // ele.nativeElement.style.border = "2px solid red"
  }
  ngOnInit() {
    this.greyedOut(this.ele.nativeElement);

  }
  private greyedOut(element) {
    if(this.userDetails.roles[0].accessLevel != 1)
    {
      this.renderer.setAttribute(element,DISABLED,"true");
    }
    else
    {
      this.renderer.removeAttribute(element,DISABLED);
    }
    
  }

}
